class ConsentModal {
  constructor(root = document.querySelector('.kkg-consent')) {
    this.root = root;
  }

  init() {
    if (!this.root || !window.KKGConsent) {
      return;
    }

    this.popupConsent = this.root.querySelector('.popup-consent');
    this.popupManageConsent = this.root.querySelector('.popup-manage-consent');
    this.acceptButtons = this.root.querySelectorAll('.accept-cookies');
    this.closeButtons = this.root.querySelectorAll('.popup-close');
    this.manageButton = this.root.querySelector('.manage-cookies');
    this.saveSettingsButton = this.root.querySelector('.save-settings');
    this.analyticsInput = this.root.querySelector('#manage-analytics-cookies');
    this.marketingInput = this.root.querySelector('#manage-marketing-cookies');

    this.bindEvents();
    this.syncInputs();

    if (!window.KKGConsent.hasChoice()) {
      this.show();
    }
  }

  bindEvents() {
    this.acceptButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.KKGConsent.acceptAll();
        this.hide();
      });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.KKGConsent.acceptAll();
        this.hide();
      });
    });

    if (this.manageButton) {
      this.manageButton.addEventListener('click', () => {
        this.popupConsent.classList.add('hidden');
        this.popupManageConsent.classList.remove('hidden');
      });
    }

    if (this.saveSettingsButton) {
      this.saveSettingsButton.addEventListener('click', () => {
        window.KKGConsent.save({
          analytics: this.analyticsInput.checked,
          marketing: this.marketingInput.checked,
        });
        this.hide();
      });
    }
  }

  syncInputs() {
    const consent = window.KKGConsent.read();

    if (!consent) {
      this.analyticsInput.checked = true;
      this.marketingInput.checked = true;
      return;
    }

    this.analyticsInput.checked = !!consent.analytics;
    this.marketingInput.checked = !!consent.marketing;
  }

  show() {
    this.root.classList.remove('hidden');
    this.root.setAttribute('aria-hidden', 'false');
    this.popupConsent.classList.remove('hidden');
    this.popupManageConsent.classList.add('hidden');
  }

  hide() {
    this.root.classList.add('hidden');
    this.root.setAttribute('aria-hidden', 'true');
    this.popupConsent.classList.remove('hidden');
    this.popupManageConsent.classList.add('hidden');
  }
}

export default ConsentModal;



// WEBPACK FOOTER //
// ./scripts/util/consent-modal.js